import { dateValueFormatter } from '../../../../util/formatter';

export default function ReportsColumnDefinition(
  local,
  city,
  district,
) {
  const colDef = [{
    type: 'string',
    field: 'status',
    headerName: local.status,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'definition',
    headerName: local.definition,
    minWidth: 250,
    flex: 1,
  }, {
    type: 'date',
    field: 'date',
    headerName: local.date,
    valueFormatter: dateValueFormatter,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'creator',
    headerName: local.creator,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'date',
    field: 'updatedAt',
    headerName: local.updatedAt,
    valueFormatter: dateValueFormatter,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'editor',
    headerName: local.editor,
    minWidth: 150,
    flex: 1,
  }];
  if (!city) {
    colDef.unshift({
      field: 'city',
      type: 'string',
      headerName: local.city,
      minWidth: 180,
      flex: 1,
    });
  }
  if (!district) {
    colDef.unshift({
      field: 'district',
      type: 'string',
      headerName: local.district,
      minWidth: 180,
      flex: 1,
    });
  }
  return colDef;
}
